import 'css-chunksrc/client/scenes/workloads/header/filters/styles.scss';export default {
  "filters": "_filters_1f1dr_1",
  "resetButton": "_resetButton_1f1dr_9",
  "label": "_label_1f1dr_17",
  "section": "_section_1f1dr_23"
};